import React, { Fragment } from 'react'
import { withStyles } from 'material-ui/styles'
import PropTypes from 'prop-types'
import { Grid, Paper, Typography } from 'material-ui'

const styles = theme => ({
  message: {
    backgroundColor: "#4ccfff",
    borderRadius: 6,
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 12,
    paddingRight: 12,
    margin: 12,
  },
});

class MessageMeText extends React.Component {
  state = {

  };

  render() {
    const { classes, theme } = this.props;

    return(
      <Grid container>
        <Grid item style={{maxWidth: "60%"}}>
          <Paper className={classes.message}>
            <Typography variant="subheading">{this.props.text}</Typography>
            <Typography variant="caption" align="right">{this.props.time}</Typography>
          </Paper>
        </Grid>
      </Grid>
    );
  }
}

MessageMeText.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  text: PropTypes.object.isRequired,
  time: PropTypes.object.isRequired,
}

export default withStyles(styles, { withTheme: true })(MessageMeText);



// WEBPACK FOOTER //
// ./src/Components/Layout/MessagePartnerText.js